"use client";

import { getStoredConsent } from "@/lib/analytics/consent";
import { getAttributionSnapshot } from "@/lib/attribution";
import type { ElyAnalyticsConsentInput } from "@/lib/consent/bookingConsent";

export function getCheckoutAnalyticsConsent(): ElyAnalyticsConsentInput | undefined {
  const consent = getStoredConsent();
  if (!consent) return undefined;
  return {
    analytics: consent.analytics,
    version: consent.version,
    updatedAt: consent.updatedAt,
    ...(consent.analytics === "granted" ? { attribution: getAttributionSnapshot() } : {}),
  };
}
